import Button from '@cobliteam/ui/components/Button';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Icon, { type IconNames } from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';
import type { ReactNode } from 'react';
import { type ColorKeys, cardColorClass, iconColorClass } from './utils';

type VehicleCardHeaderProps = {
  icon: IconNames;
  color?: ColorKeys;
  title: ReactNode;
  subtitle?: ReactNode;
  link?: string;
  linkTooltip?: string;
  onLinkClick?: () => void;
};

const VehicleCardHeader = ({ icon, color, title, subtitle, link, linkTooltip, onLinkClick }: VehicleCardHeaderProps) => {
  return (
    <div className='flex w-full items-center justify-between gap-2 p-1'>
      <div className='flex items-start gap-2'>
        <div className={cn('rounded-md border bg-gray-4 p-3', cardColorClass(color), iconColorClass(color))}>
          <Icon name={icon} className='size-5' />
        </div>
        <div className='flex flex-col'>
          <div className='font-semibold text-base'>{title}</div>
          {subtitle ? <div className='flex items-center gap-1 text-sm'>{subtitle}</div> : null}
        </div>
      </div>
      {link && (
        <a href={link} onClick={onLinkClick}>
          <Tooltip content={linkTooltip}>
            <Button variant='outlined' size='sm' color='default' icon={<Icon name='square-arrow-out-up-right' />} />
          </Tooltip>
        </a>
      )}
    </div>
  );
};

export default VehicleCardHeader;
